
  import { css } from 'lit';
  export const styles = css`:host{--track-color: var(--ig-linear-bar-track-color, var(--ig-gray-300));--stripes-color: var(--ig-linear-bar-stripes-color, hsl(from var(--ig-gray-900) h s l/0.7));--ig-theme-variant: dark}`;
  